import { nanoid } from "@reduxjs/toolkit";
import React, { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import { getOnlyUnique } from "../components/commonWidget";
import tableIcon from "../components/custom/assets/images/dashboard/table_icon.svg";
import { MultiSelect } from "../components/custom/components";
import FormInput2 from "../components/custom/components/FormInput2";
import {
  Tbody,
  Thead,
} from "../components/custom/components/TradeCategoryPerformanceTable";
import TransactionTable from "../components/custom/components/TransactionTable";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import { defaultPortfolio, DropDownOption1, PAGE_SIZE } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import { CSVdownload, handleDownloadPDF1 } from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { BrandType } from "../redux/actions/brandActions";
import { BrandCompanyType } from "../redux/actions/brandCompanyActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeCategoryType } from "../redux/actions/tradeCategoryActions";
import { TradeSubCategoryType } from "../redux/actions/tradeSubCategoryActions";
import { StoreState } from "../redux/store";
import {
  CatSubCatCompanyWithBrandRelationDataType,
} from "./TransactionBillWiseReport";
// import Loader from "../components/custom/components/Loader";
import { areaType } from "../redux/actions/areaActions";
import { outletType } from "../redux/actions/outletActions";
import { UserLog } from "../config/common";
import { useLocation } from "react-router-dom";
import SingleSelect from "../components/custom/components/SingleSelect";
import SingleSelect1 from "../components/custom/components/SingleSelect1";


export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}

export interface ConsolidatedDaywiseRecord {
  tradecategory: string;
  tradesubcategory: string;
  brandname: string;
  terminal?: string;
  location: string;
  landmark: string;
  a01: string;
  a02: string;
  a03: string;
  a04: string;
  a05: string;
  a06: string;
  a07: string;
  a08: string;
  a09: string;
  a10: string;
  a11: string;
  a12: string;
  a13: string;
  a14: string;
  a15: string;
  a16: string;
  a17: string;
  a18: string;
  a19: string;
  a20: string;
  a21: string;
  a22: string;
  a23: string;
  a24: string;
  a25: string;
  a26: string;
  a27: string;
  a28: string;
  a29: string;
  a30: string;
  a31: string;
  rsvalue?: string;
  rspercent?: string;
}

export interface ConsolidatedDaywiseReportType {
  portfolio: number;
  record: ConsolidatedDaywiseRecord[];
  count?: number;
}

const TransactionConsolidatedDaywiseReport: React.FC = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const pageName = useLocation()
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);

  const authUserSiteId = authUser?.siteId;
  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>((state) => state?.site);
  const brandOption = useSelector<StoreState, BrandType[]>(
    (state) => state?.brand
  );
  const brandCompanyOption = useSelector<StoreState, BrandCompanyType[]>(
    (state) => state?.brandCompany
  );

  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );
  
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );
  const categoryOption = useSelector<StoreState, TradeCategoryType[]>(
    (state) => state?.tradeCategory
  );
  const subCategoryOption = useSelector<StoreState, TradeSubCategoryType[]>(
    (state) => state?.tradeSubCategory
  );
  const filteredBrandCompany = brandCompanyOption?.filter(
    (a) => a?.retailid !== null
  );

  const filteredBrand = brandOption?.filter((a) => {
    return brandCompanyOption?.some(
      (b) =>
        b?.id?.toString() === a?.companyid?.toString() && b?.retailid !== null
    );
  });

  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);

  const br =
    authUser?.brandId !== undefined && authUser?.brandId !== null
      ? authUser?.brandId?.split(",")
      : [];

  let brandData = br
    ?.map((b) => {
      return filteredBrand?.filter((f) => f?.id?.toString() === b?.toString());
    })
    ?.flat(1);

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<DropDownOption[]>([]);

  const [categories, setCategories] = useState<DropDownOption[]>([]);
  const [subCategories, setSubCategories] = useState<DropDownOption[]>([]);

  //loader
  const [fileLoader, setFileLoader] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [pag, setPag] = useState<boolean>(false);

  const [
    catSubCatCompanyWithBrandRelationData,
    setCatSubCatCompanyWithBrandRelationData,
  ] = useState<CatSubCatCompanyWithBrandRelationDataType[]>([]);

  // const [disableSite, setDisableSite] = useState<boolean>(false);
  const [disableBrand, setDisableBrand] = useState<boolean>(false);
  const [disableSubCategory, setDisableSubCategory] = useState<boolean>(false);

  const [consolidatedDaywiseData, setConsolidatedDaywiseData] = useState<
    ConsolidatedDaywiseReportType[]
  >([]);

  const limit = PAGE_SIZE;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);

  const [valueIn, setValueIn] = useState<string>("");
  const [locations, setLocations] = useState<DropDownOption[]>([]);
  const [disableLocality, setDisableLocality] = useState<boolean>(false);
  const [yearAndMonth, setYearAndMonth] = useState<Date>(new Date());
  const [condition,setCondition] = useState<boolean>(false)
  const [portfoliosOption, setPortfoliosOption] = useState<DropDownOption1>(defaultPortfolio);
  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [portfolioDrop, setPortfolioDrop] = useState<DropDownOption[]>([]);

  const handleSelectedRowsChange = (selectedRows: string[]) => {
    setSelectedRows(selectedRows);
  };

  const handleOff = (conditionVal: boolean) => {
    setCondition(conditionVal);
  };

  

  const locality = useMemo<string[]>(() => {
    return locations?.map((p) => {
      return p?.label;
    });
  }, [locations]);


  const brandFilteredByCompany = useMemo<BrandType[]>(() => {
    if (subCategories?.length > 0) {
      let brands: BrandType[] = [];
      catSubCatCompanyWithBrandRelationData?.forEach((s) => {
        subCategories?.forEach((sb) => {
          let obj = s?.record?.find((r) =>
            r?.tradesubcatids?.split(",")?.includes(sb?.value?.toString())
          );
          obj?.brandids?.split(",")?.forEach((m) => {
            let bc = brandData?.find((f) => f?.id?.toString() === m);
            brands?.push(bc!);
          });
        });
      });

      return brands?.filter(getOnlyUnique);
    } else if (categories?.length > 0) {
      let brands: BrandType[] = [];
      catSubCatCompanyWithBrandRelationData?.forEach((s) => {
        categories?.forEach((cat) => {
          let obj = s?.record?.find(
            (r) => r?.tradecatid?.toString() === cat?.value?.toString()
          );
          obj?.brandids?.split(",")?.forEach((m) => {
            let bc = brandData?.find((f) => f?.id?.toString() === m);
            brands?.push(bc!);
          });
        });
      });
      return brands;
    } else return brandData;
  }, [
    brandData,
    catSubCatCompanyWithBrandRelationData,
    categories,
    subCategories,
  ]);

  const subCategoryFilteredByCategory = useMemo<TradeSubCategoryType[]>(() => {
    if (categories?.length === 1) {
      return subCategoryOption?.filter((sc) => {
        return sc?.catid === categories[0]?.value;
      });
    } else return subCategoryOption;
  }, [categories, subCategoryOption]);

  const handlePortfolioDrop = (selected: any) => {
    if(fileLoader===false){
    if(selected.length>0){
      const selectedPortfolio = selected as DropDownOption[];
      if(selectedPortfolio[0].value!==null&&selectedPortfolio[0].value!==0){
        setPortfolioDrop(selectedPortfolio)
        setPortfolios(selectedPortfolio[0]?.value?.toString())
        const data = { ...selectedOption, portfolio: selectedPortfolio[0]?.value?.toString() };
        dispatch(addToSelectedOption(data));
        setOffset(0);
        setPag(false);
      }
    }
  }
  };

  const handleClearPortfolio = () =>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);

      if(fileLoader===false){
      setLocations([]);
      const data = { ...selectedOption, portfolio: b[0]?.id?.toString(),location:'',locations:[]};
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  }
  }
  const handleLocationsChange = (value: DropDownOption[]) => {
    if (fileLoader === false) {
      setLocations(value);
      const data = {
        ...selectedOption,
        locations: value,
      };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };

  const handleCategoriesChange = (value: DropDownOption[]) => {
    if (fileLoader === false) {
      setCategories(value);
      const data = {
        ...selectedOption,
        categories: value,
        subCategories: [],
        companies: [],
        brands: [],
      };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };

  const handleSubCategoriesChange = (value: DropDownOption[]) => {
    if (fileLoader === false) {
      setSubCategories(value);
      setBrands([]);
      const data = {
        ...selectedOption,
        subCategories: value,
        companies: [],
        brands: [],
      };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };

  const handleBrandsChange = (value: DropDownOption[]) => {
    if (fileLoader === false) {
      setBrands(value);
      const data = { ...selectedOption, brands: value };
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
    }
  };

  const portFilter = portfolioOption?.filter((a)=>a?.id?.toString()===portfolios?.toString())

 
  let localitiesName = ''
  if(locations?.length>0){
    let locNameArr: string[] = [];
    locations?.map((s) => {
      locNameArr?.push(s?.label);
    });
    localitiesName = locNameArr?.join(", ");
  }

  

  let categoriesName =  '' 
  if (categories?.length > 0) {
    let catNameArr: string[] = [];
    categories?.map((s) => {
      catNameArr?.push(s?.label);
    });
    categoriesName = catNameArr?.join(", ");
  }

  let subcategoriesName =  '' 
  if (subCategories?.length > 0) {
    let subcatNameArr: string[] = [];
    subCategories?.map((s) => {
      subcatNameArr?.push(s?.label);
    });
    subcategoriesName = subcatNameArr?.join(", ");
  }


  let brandsName = ''
  if(brands?.length>0){
    let brandNameArr: string[] = [];
    brands?.map((s) => {
      brandNameArr?.push(s?.label);
    });
    brandsName = brandNameArr?.join(", ");
  }


  const combinedValues = [
    ...portFilter?.map(a => `Portfolio: ${a?.name}`),           
    categoriesName !== '' ? `Trade Category: ${categoriesName}` : '' , 
    subcategoriesName !== '' ? `Trade Sub Category: ${subcategoriesName}` : '' , 
    localitiesName!== '' ? `Locality: ${localitiesName}` : '' , 
    brandsName !== '' ? `Brand: ${brandsName}` : '' ,  
    `Year: ${yearAndMonth?.getFullYear()}, Month: ${yearAndMonth?.getMonth()+1}`,
  ]
  ?.filter(name => name && name?.trim() !== '') 
  ?.join(', ');  


  const tHead: Thead[] = [
    {
      id: "Trade Category",
      children: "Trade Category",
      text: "Trade Category",
    },
    {
      id: "Trade Sub Category",
      children: "Trade Sub Category",
      text: "Trade Sub Category",
    },
    { id: "Brand Name", children: "Brand Name", text: "Brand Name" },
    // { id: 'Terminal', children: 'Terminal', text: 'Terminal' },
    { id: "Location", children: "Location", text: "Location" },
    { id: "Landmark", children: "Landmark", text: "Landmark" }
  ];
  if(!selectedOption?.isOutletUser){
    tHead?.push(
    { id: "Revenue Share(%)", children: "Revenue Share(%)", text: "Revenue Share(%)" },
    { id: "Revenue", children: "Revenue", text: "Revenue" },
    )
  }
    tHead?.push(
      { id: "1", children: "1", text: "1" },
      { id: "2", children: "2", text: "2" },
      { id: "3", children: "3", text: "3" },
      { id: "4", children: "4", text: "4" },
      { id: "5", children: "5", text: "5" },
      { id: "6", children: "6", text: "6" },
      { id: "7", children: "7", text: "7" },
      { id: "8", children: "8", text: "8" },
      { id: "9", children: "9", text: "9" },
      { id: "10", children: "10", text: "10" },
      { id: "11", children: "11", text: "11" },
      { id: "12", children: "12", text: "12" },
      { id: "13", children: "13", text: "13" },
      { id: "14", children: "14", text: "14" },
      { id: "15", children: "15", text: "15" },
      { id: "16", children: "16", text: "16" },
      { id: "17", children: "17", text: "17" },
      { id: "18", children: "18", text: "18" },
      { id: "19", children: "19", text: "19" },
      { id: "20", children: "20", text: "20" },
      { id: "21", children: "21", text: "21" },
      { id: "22", children: "22", text: "22" },
      { id: "23", children: "23", text: "23" },
      { id: "24", children: "24", text: "24" },
      { id: "25", children: "25", text: "25" },
      { id: "26", children: "26", text: "26" },
      { id: "27", children: "27", text: "27" },
      { id: "28", children: "28", text: "28" },
      { id: "29", children: "29", text: "29" },
      { id: "30", children: "30", text: "30" },
      { id: "31", children: "31", text: "31" }
    );

  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    } else if (brands?.length <= 0) {
      toast("Select Brand", ToastTypes?.ERROR);
      error = true;
    } else if (
      yearAndMonth === null ||
      (yearAndMonth !== null &&
        yearAndMonth?.getFullYear()?.toString() === "" &&
        yearAndMonth?.getMonth()?.toString() === "")
    ) {
      toast("Select month and year", ToastTypes?.ERROR);
      error = true;
    }

    const yr = yearAndMonth?.getFullYear();
    const mon = month[yearAndMonth?.getMonth()];

    var getData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: yr,
      month: mon,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };

    if (
      error === false &&
      getData !== undefined &&
      getData?.limit !== "" &&
      getData?.offset !== ""
    ) {
      if (pag === false) {
        setLoader(true);
      }
      api
        .post<APIResponse<{ records: ConsolidatedDaywiseReportType[] }>>(
          `kpi/report/consolidatedDaywise`,
          getData,
          config
        )
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setLoader(false);
            setPag(true);
            setConsolidatedDaywiseData(result);
            setCondition(false)
            if(authUser){
              const logProps1 = {
                action: 'Apply',
                event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
              };
              UserLog(logProps1)
            }
            
          }
        })
        .catch((error) => {});
    } else {
      setConsolidatedDaywiseData([]);
      setLoader(false);
      setPag(true);
      setCondition(false)
    }
  };

  const handlePag = () => {
    setPag(true);
  };
  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
    }else{
      setDisableLocality(false);
    }
  },[authUser, outletList,selectedOption]);


  useEffect(() => {
    if (portfolios !== "" && brands?.length !== 0 && fileLoader === false)
      handleApply();
  }, [portfolios]);

  const fetchDataForDownload = async () => {
    let error = false;

    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    } else if (brands?.length <= 0) {
      toast("Select Brand", ToastTypes?.ERROR);
      error = true;
    } else if (
      yearAndMonth === null ||
      (yearAndMonth !== null &&
        yearAndMonth?.getFullYear()?.toString() === "" &&
        yearAndMonth?.getMonth()?.toString() === "")
    ) {
      toast("Select month and year", ToastTypes?.ERROR);
      error = true;
    }

    const yr = yearAndMonth?.getFullYear();
    const mon = month[yearAndMonth?.getMonth()];

    var getData = {
      portfolio: portfolio,
      site: site,
      locality: locality,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: yr,
      month: mon,
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };

    if (error === false && getData !== undefined) {
      const response = await api.post<
        APIResponse<{ records: ConsolidatedDaywiseReportType[] }>
      >(`kpi/report/consolidatedDaywise`, getData, config);

      if (response?.status === 200 && response?.data?.data) {
        return response?.data?.data?.records;
      }
    }

    return [];
  };

  const getDownloadData = (Data: ConsolidatedDaywiseReportType[]) => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];

    const tbody = Data;

    tbody?.forEach((bill, i) => {
      bill?.record?.forEach((item) => {
        var tBody: Tbody[] = [];
        tBody?.push(
          {
            id: nanoid(),
            theadId: "Trade Category",
            children: item?.tradecategory,
            text: item?.tradecategory,
          },
          {
            id: nanoid(),
            theadId: "Trade Sub Category",
            children: item?.tradesubcategory,
            text: item?.tradesubcategory,
          },
          {
            id: nanoid(),
            theadId: "Brand Name",
            children: item?.brandname,
            text: item?.brandname,
          },
          {
            id: nanoid(),
            theadId: "Terminal",
            children: item?.terminal,
            text: item?.terminal,
          },
          {
            id: nanoid(),
            theadId: "Location",
            children: item?.location,
            text: item?.location?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Landmark",
            children: item?.landmark,
            text: item?.landmark,
          }
        )
        if(!selectedOption?.isOutletUser){
          tBody?.push(
            {
              id: nanoid(),
              theadId: "Revenue Share(%)",
              children: item?.rspercent,
              text: item?.rspercent,
            },
            {
              id: nanoid(),
              theadId: "Revenue",
              children: item?.rsvalue,
              text: item?.rsvalue,
            },
          );
        }
        tBody?.push(
          {
            id: nanoid(),
            theadId: "1",
            children: item?.a01,
            text: item?.a01,
          },
          {
            id: nanoid(),
            theadId: "2",
            children: item?.a02,
            text: item?.a02,
          },
          {
            id: nanoid(),
            theadId: "3",
            children: item?.a03,
            text: item?.a03,
          },
          {
            id: nanoid(),
            theadId: "4",
            children: item?.a04,
            text: item?.a04,
          },
          {
            id: nanoid(),
            theadId: "5",
            children: item?.a05,
            text: item?.a05,
          },
          {
            id: nanoid(),
            theadId: "6",
            children: item?.a06,
            text: item?.a06,
          },
          {
            id: nanoid(),
            theadId: "7",
            children: item?.a07,
            text: item?.a07,
          },
          {
            id: nanoid(),
            theadId: "8",
            children: item?.a08,
            text: item?.a08,
          },
          {
            id: nanoid(),
            theadId: "9",
            children: item?.a09,
            text: item?.a09,
          },
          {
            id: nanoid(),
            theadId: "10",
            children: item?.a10,
            text: item?.a10,
          },
          {
            id: nanoid(),
            theadId: "11",
            children: item?.a11,
            text: item?.a11,
          },
          {
            id: nanoid(),
            theadId: "12",
            children: item?.a12,
            text: item?.a12,
          },
          {
            id: nanoid(),
            theadId: "13",
            children: item?.a13,
            text: item?.a13,
          },
          {
            id: nanoid(),
            theadId: "14",
            children: item?.a14,
            text: item?.a14,
          },
          {
            id: nanoid(),
            theadId: "15",
            children: item?.a15,
            text: item?.a15,
          },
          {
            id: nanoid(),
            theadId: "16",
            children: item?.a16,
            text: item?.a16,
          },
          {
            id: nanoid(),
            theadId: "17",
            children: item?.a17,
            text: item?.a17,
          },
          {
            id: nanoid(),
            theadId: "18",
            children: item?.a18,
            text: item?.a18,
          },
          {
            id: nanoid(),
            theadId: "19",
            children: item?.a19,
            text: item?.a19,
          },
          {
            id: nanoid(),
            theadId: "20",
            children: item?.a20,
            text: item?.a20,
          },
          {
            id: nanoid(),
            theadId: "21",
            children: item?.a21,
            text: item?.a21,
          },
          {
            id: nanoid(),
            theadId: "22",
            children: item?.a22,
            text: item?.a22,
          },
          {
            id: nanoid(),
            theadId: "23",
            children: item?.a23,
            text: item?.a23,
          },
          {
            id: nanoid(),
            theadId: "24",
            children: item?.a24,
            text: item?.a24,
          },
          {
            id: nanoid(),
            theadId: "25",
            children: item?.a25,
            text: item?.a25,
          },
          {
            id: nanoid(),
            theadId: "26",
            children: item?.a26,
            text: item?.a26,
          },
          {
            id: nanoid(),
            theadId: "27",
            children: item?.a27,
            text: item?.a27,
          },
          {
            id: nanoid(),
            theadId: "28",
            children: item?.a28,
            text: item?.a28,
          },
          {
            id: nanoid(),
            theadId: "29",
            children: item?.a29,
            text: item?.a29,
          },
          {
            id: nanoid(),
            theadId: "30",
            children: item?.a30,
            text: item?.a30,
          }
        );
        tableBody?.push(tBody);
      });
    });

    return { tbody: tableBody, thead: tableHead };
  };

  const handleCsvDownload = async () => {
    setFileLoader(true);
    const csvData = await fetchDataForDownload();
    if (
      csvData[0]?.record?.length !== 0 &&
      csvData[0]?.record?.length !== undefined
    ) {
      const d = { ...getDownloadData(csvData) };
      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);
      const csvHead = filteredHead;
      const csvBody = d?.tbody;

      const head = [csvHead?.map((h) => h?.text || "") || []];
      const body =
        csvBody?.map((tr, i) => {
          return (
            csvHead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const rows = [...head, ...body];
      const props = {
        rows: rows,
        fileName: "Consolidated Daywise Report",
      };
      CSVdownload(props);
      setFileLoader(false);
    } else {
      setFileLoader(false);
    }
    setFileLoader(false);
  };

  const handlePdfDownload = async () => {
    setFileLoader(true);
    const pdfData = await fetchDataForDownload();
    if (
      pdfData[0]?.record?.length !== 0 &&
      pdfData[0]?.record?.length !== undefined
    ) {
      const d = { ...getDownloadData(pdfData) };
      const filteredHead = d?.thead
        ?.map((a) => {
          const foundObject = selectedRows
            ?.map((b) => {
              if (a?.text?.toString() === b?.toString()) {
                return a;
              }
            })
            ?.find((obj) => obj !== undefined);

          if (foundObject !== undefined) {
            return foundObject;
          }
        })
        ?.filter((obj) => obj !== undefined);
      const thead = filteredHead;
      const tbody = d?.tbody;

      const head = [thead?.map((h) => h?.text || "") || []];
      const body =
        tbody?.map((tr, i) => {
          return (
            thead?.map((th, j) => {
              const col = tr?.find((r) => r?.theadId === th?.id);
              return col?.text || "";
            }) || []
          );
        }) || [];

      const props = {
        head: head,
        body: body,
        fileName: "Consolidated Daywise Report",
        title: "Consolidated Daywise Report",
      };

      handleDownloadPDF1(props);
      setFileLoader(false);
    } else {
      setFileLoader(false);
    }
    setFileLoader(false);
  };

  const getTableData = () => {
    var tableHead: Thead[] = tHead;
    var tableBody: Tbody[][] = [];
    const tbody = consolidatedDaywiseData;

    tbody?.forEach((bill, i) => {
      bill?.record?.forEach((item) => {
        var tBody: Tbody[] = [];
        tBody?.push(
          {
            id: nanoid(),
            theadId: "Trade Category",
            children: item?.tradecategory,
            text: item?.tradecategory,
          },
          {
            id: nanoid(),
            theadId: "Trade Sub Category",
            children: item?.tradesubcategory,
            text: item?.tradesubcategory,
          },
          {
            id: nanoid(),
            theadId: "Brand Name",
            children: item?.brandname,
            text: item?.brandname,
          },
          {
            id: nanoid(),
            theadId: "Terminal",
            children: item?.terminal,
            text: item?.terminal,
          },
          {
            id: nanoid(),
            theadId: "Location",
            children: item?.location,
            text: item?.location?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Landmark",
            children: item?.landmark,
            text: item?.landmark,
          }
        )
        if(!selectedOption?.isOutletUser){
          tBody?.push(
            {
              id: nanoid(),
              theadId: "Revenue Share(%)",
              children: item?.rspercent,
              text: item?.rspercent,
            },
            {
              id: nanoid(),
              theadId: "Revenue",
              children: item?.rsvalue,
              text: item?.rsvalue,
            },
          );
        }
        tBody?.push(
          {
            id: nanoid(),
            theadId: "1",
            children: item?.a01,
            text: item?.a01,
          },
          {
            id: nanoid(),
            theadId: "2",
            children: item?.a02,
            text: item?.a02,
          },
          {
            id: nanoid(),
            theadId: "3",
            children: item?.a03,
            text: item?.a03,
          },
          {
            id: nanoid(),
            theadId: "4",
            children: item?.a04,
            text: item?.a04,
          },
          {
            id: nanoid(),
            theadId: "5",
            children: item?.a05,
            text: item?.a05,
          },
          {
            id: nanoid(),
            theadId: "6",
            children: item?.a06,
            text: item?.a06,
          },
          {
            id: nanoid(),
            theadId: "7",
            children: item?.a07,
            text: item?.a07,
          },
          {
            id: nanoid(),
            theadId: "8",
            children: item?.a08,
            text: item?.a08,
          },
          {
            id: nanoid(),
            theadId: "9",
            children: item?.a09,
            text: item?.a09,
          },
          {
            id: nanoid(),
            theadId: "10",
            children: item?.a10,
            text: item?.a10,
          },

          {
            id: nanoid(),
            theadId: "11",
            children: item?.a11,
            text: item?.a11,
          },
          {
            id: nanoid(),
            theadId: "12",
            children: item?.a12,
            text: item?.a12,
          },
          {
            id: nanoid(),
            theadId: "13",
            children: item?.a13,
            text: item?.a13,
          },
          {
            id: nanoid(),
            theadId: "14",
            children: item?.a14,
            text: item?.a14,
          },
          {
            id: nanoid(),
            theadId: "15",
            children: item?.a15,
            text: item?.a15,
          },
          {
            id: nanoid(),
            theadId: "16",
            children: item?.a16,
            text: item?.a16,
          },
          {
            id: nanoid(),
            theadId: "17",
            children: item?.a17,
            text: item?.a17,
          },
          {
            id: nanoid(),
            theadId: "18",
            children: item?.a18,
            text: item?.a18,
          },
          {
            id: nanoid(),
            theadId: "19",
            children: item?.a19,
            text: item?.a19,
          },
          {
            id: nanoid(),
            theadId: "20",
            children: item?.a20,
            text: item?.a20,
          },

          {
            id: nanoid(),
            theadId: "21",
            children: item?.a21,
            text: item?.a21,
          },
          {
            id: nanoid(),
            theadId: "22",
            children: item?.a22,
            text: item?.a22,
          },
          {
            id: nanoid(),
            theadId: "23",
            children: item?.a23,
            text: item?.a23,
          },
          {
            id: nanoid(),
            theadId: "24",
            children: item?.a24,
            text: item?.a24,
          },
          {
            id: nanoid(),
            theadId: "25",
            children: item?.a25,
            text: item?.a25,
          },
          {
            id: nanoid(),
            theadId: "26",
            children: item?.a26,
            text: item?.a26,
          },
          {
            id: nanoid(),
            theadId: "27",
            children: item?.a27,
            text: item?.a27,
          },
          {
            id: nanoid(),
            theadId: "28",
            children: item?.a28,
            text: item?.a28,
          },
          {
            id: nanoid(),
            theadId: "29",
            children: item?.a29,
            text: item?.a29,
          },
          {
            id: nanoid(),
            theadId: "30",
            children: item?.a30,
            text: item?.a30,
          }
        );
        tableBody?.push(tBody);
      });
    });

    return { tbody: tableBody, thead: tableHead };
  };

  useEffect(() => {
    const header = tHead
      ?.map((a) => a?.text)
      ?.filter((id): id is string => typeof id === "string" && id !== undefined);
    setSelectedRows(header);
  }, []);

  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);
  
  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  const brand = useMemo<number[]>(() => {
    return brands?.map((p) => {
      return p?.value;
    });
  }, [brands]);

  const category = useMemo<number[]>(() => {
    return categories?.map((p) => {
      return p?.value;
    });
  }, [categories]);

  const subCategory = useMemo<number[]>(() => {
    return subCategories?.map((p) => {
      return p?.value;
    });
  }, [subCategories]);

  useEffect(() => {
    setOffset(0);
  }, [yearAndMonth]);

 
  useEffect(()=>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
    }
},[portfolioOption,selectedOption])

  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);

  useEffect(() => {
    if (selectedOption?.categories && selectedOption?.categories?.length !== 0)
      setCategories(selectedOption?.categories);
  }, [selectedOption]);

  useEffect(() => {
    if (selectedOption?.locations && selectedOption?.locations?.length !== 0)
      setLocations(selectedOption?.locations);
  }, [selectedOption]);

  useEffect(() => {
    if (selectedOption?.subCategories)
      setSubCategories(selectedOption?.subCategories);
  }, [selectedOption]);

  useEffect(() => {
    if (selectedOption?.brands) setBrands(selectedOption?.brands);
  }, [selectedOption]);

  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    // let i = 1;
    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);

  useEffect(() => {
    if (consolidatedDaywiseData?.length > 0)
      setLength(
        consolidatedDaywiseData[0]?.count
          ? consolidatedDaywiseData[0]?.count
          : 0
      );
  }, [consolidatedDaywiseData]);

  useEffect(() => {
    if (categories?.length > 1) {
      setDisableSubCategory(true);
      setSubCategories([]);
    } else {
      setDisableSubCategory(false);
    }
  }, [categories]);

  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);

  useEffect(() => {
    var getData = {
      portfolio: portfolio,
    };

    if (portfolio?.length > 0 && getData !== undefined) {
      api
        .post<
          APIResponse<{ records: CatSubCatCompanyWithBrandRelationDataType[] }>
        >(`filter/catSubcatCompanyRelationWithBrand`, getData, config)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setCatSubCatCompanyWithBrandRelationData(result);
          }
        })
        .catch((error) => {});
    } else {
      setCatSubCatCompanyWithBrandRelationData([]);
    }
  }, [portfolio]);


  useEffect(()=>{
    if(authUser){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName?.pathname?.replace("\\", " ")} page | Visited `
    };
    UserLog(logProps1)
  }
  },[])

  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
          >
            <h4 className="b-title">Consolidated Daywise Report</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
            <div className="row">
              <div className="col-sm-6 col-lg-3">
                {/* <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultPortfolio,
                    ...portfolioData?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={portfoliosOption}
                  setSelectedOptions={handlePortfolioChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
                  <SingleSelect1
                      options={portfolioData.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={portfolioDrop}
                      setSelectedOptions={handlePortfolioDrop}
                      placeHolder="Select Portfolio"
                      onClear={handleClearPortfolio}
                      disabled = {disableLocality}
                    />
              </div>
              
              <div className="col-sm-6 col-lg-3">
              <MultiSelect
                  options={localityOption?.map((sc) => {
                    return {
                      value: sc?.id ? sc?.id : 0,
                      label: sc?.area?.toString(),
                      imgUrl: "",
                    };
                  })}
                  label=""
                  selectedOptions={locations}
                  setSelectedOptions={handleLocationsChange}
                  disabled={disableLocality}
                  placeHolder="All Locality"
                />
              </div>

              
            </div>

            <div className="row mt-1">
              <div className="col-sm-6 col-lg-3">
                <MultiSelect
                  options={categoryOption?.map((c) => {
                    return {
                      value: c?.id ? c?.id : 0,
                      label: c?.name,
                      imgUrl: "",
                    };
                  })}
                  label=""
                  selectedOptions={categories}
                  setSelectedOptions={handleCategoriesChange}
                  placeHolder="All Trade Categories"
                  disabled={disableLocality}
                />
              </div>

              <div className="col-sm-6 col-lg-3">
                <MultiSelect
                  options={subCategoryFilteredByCategory?.map((sc) => {
                    return {
                      value: sc?.id ? sc?.id : 0,
                      label: sc?.name,
                      imgUrl: "",
                    };
                  })}
                  label=""
                  selectedOptions={subCategories}
                  setSelectedOptions={handleSubCategoriesChange}
                  disabled={disableLocality}
                  placeHolder="All Trade Sub Categories"
                />
              </div>


              <div className="col-sm-6 col-lg-3">
                <MultiSelect
                  options={brandFilteredByCompany
                    ?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })
                    ?.map((b) => {
                      return {
                        value: b?.id ? b?.id : 0,
                        label: b?.name,
                        imgUrl: b?.logourl,
                      };
                    })}
                  label=""
                  selectedOptions={brands}
                  setSelectedOptions={handleBrandsChange}
                  disabled={disableLocality}
                  placeHolder="All Brands"
                  filterText=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card mt-3">
            <div className="card-body">
              <div className="row mb-1">
                <div className="col-lg-6 col-sm-12">
                  <div className="float-start">
                    <h5 className="header-title mt-1">
                      <img src={tableIcon} alt="icon"></img>Consolidated Daywise
                      Report
                    </h5>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="float-end hstack gap-1">
                    
                    <div
                      className="col-sm-6 col-md-6 col-lg-6"
                      style={{ width: "133px" }}
                    >
                      <div className="DateContainer">
                        <span className="dateInput">
                          <DatePicker
                            id="DatePicker"
                            // type="string"
                            className="text-center fw-bold form-control"
                            selected={yearAndMonth}
                            onChange={(date: any) => setYearAndMonth(date)}
                            showMonthYearPicker
                            dateFormat="MM/yyyy"
                            yearItemNumber={8}
                            //     required
                          />
                        </span>
                        <span className="icon">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                              fill="#6C757D"
                            ></path>
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <TransactionTable
                data={[]}
                {...getTableData()}
                title=""
                downloadCSV={true}
                downloadPDF={true}
                fileName="Consolidated Daywise Report"
                limit={limit}
                setOffset={setOffset}
                onClickCSV={handleCsvDownload}
                onClickPDF={handlePdfDownload}
                range={range}
                valueInString={valueIn}
                onPageNoChange={pag && (offset > 0||condition) ? handleApply : undefined}
                handlePag={pag ? handlePag : undefined}
                onOffchange={handleOff}
                fLoader={fileLoader}
                onSelectedRowsChange={handleSelectedRowsChange}
              />
            </div>
          </div>
        </div>
      </div>
    </UserLayout>
  );
};
export default TransactionConsolidatedDaywiseReport;
